export default __webpack_public_path__ + "static/media/98-01_header_invoice.5d08550c.png";